import { memo, useCallback } from 'react';

import classNames from 'classnames';
import PropTypes from 'prop-types';

import Typography from 'components/UI/Typography/Typography';

import styles from './Filter.module.scss';

const Filter = ({ label, value, isActive, onClick, Icon }) => {
  const handleClick = useCallback(() => onClick(value), [onClick, value]);

  return (
    <div
      onClick={handleClick}
      className={classNames(styles.root, {
        [styles.active]: isActive,
      })}
    >
      <Icon />
      <Typography weight="medium" color="inherit">
        {label}
      </Typography>
    </div>
  );
};

Filter.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  isActive: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired,
  Icon: PropTypes.elementType.isRequired,
};

export default memo(Filter);
